var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAiriToken = function SvgIconAiriToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M7.56 0a8.1 8.1 0 0 0-3.37 1.218l2.015.501zM5.209 2.988l.996-1.269-2.016-.495z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m5.209 2.988-1.02-1.764-.415 2.049z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M4.19 1.224a8.2 8.2 0 0 0-2.466 2.459l2.05-.416zM3.49 4.702l.284-1.43-2.05.416zM6.205 1.719l1.355.341V0zM.5 7.058h2.056L2.22 5.59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M3.49 4.702 1.723 3.688l.495 2.015z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M1.724 3.688A8 8 0 0 0 .5 7.058l1.72-1.355zM6.205 1.719 5.21 2.983a6 6 0 0 1 2.352-.928zM5.209 2.988l-1.43.285-.29 1.429a6.2 6.2 0 0 1 1.72-1.714"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m3.49 4.701-1.265.997.336 1.354c.137-.854.461-1.65.928-2.35M.5 8.942a8.1 8.1 0 0 0 1.219 3.37l.5-2.015z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m3.484 11.293-1.264-.996-.501 2.015zM1.724 12.312a8.2 8.2 0 0 0 2.46 2.464l-.416-2.049z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m5.203 13.012-1.43-.29.41 2.054zM2.22 10.297l.336-1.355H.5zM7.56 16v-2.055l-1.469.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m5.203 13.012-1.019 1.764 2.016-.5zM4.184 14.776A8.1 8.1 0 0 0 7.561 16l-1.356-1.719zM2.22 10.297l1.264.996a6 6 0 0 1-.928-2.351zM3.483 11.293l.285 1.428 1.43.29a6.2 6.2 0 0 1-1.715-1.718M5.203 13.012l.997 1.263 1.36-.33a6.2 6.2 0 0 1-2.357-.933M9.445 16a8.1 8.1 0 0 0 3.371-1.218L10.8 14.28zM11.797 13.012l-.997 1.263 2.01.501z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m11.797 13.012 1.013 1.764.416-2.049zM12.81 14.776a8.2 8.2 0 0 0 2.466-2.459l-2.05.416zM13.517 11.298l-.29 1.429 2.049-.41v-.005zM10.8 14.275l-1.355-.33V16zM16.5 8.942h-2.055l.336 1.468z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m13.517 11.298 1.759 1.014-.495-2.015zM15.276 12.312A8.1 8.1 0 0 0 16.5 8.936l-1.72 1.355zM10.8 14.275l.997-1.263a6 6 0 0 1-2.352.928zM11.797 13.018l1.43-.285.29-1.429a6.4 6.4 0 0 1-1.72 1.713"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m13.517 11.298 1.264-.996-.336-1.354a6.1 6.1 0 0 1-.928 2.35M16.5 7.058a8.1 8.1 0 0 0-1.219-3.37l-.5 2.015zM13.516 4.707l1.264.996.501-2.015z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m13.517 4.707 1.765-1.019-2.056-.41z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M15.282 3.688a8.2 8.2 0 0 0-2.46-2.464l.415 2.049zM11.797 2.988l1.43.29-.41-2.054zM14.78 5.703l-.336 1.355H16.5zM9.445 0v2.06l1.47-.335z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m11.797 2.988 1.019-1.764-2.016.5zM12.816 1.224A8.1 8.1 0 0 0 9.439 0l1.356 1.719zM14.78 5.703l-1.264-.996c.461.695.786 1.492.928 2.351zM13.516 4.707l-.285-1.428-1.429-.29a6.2 6.2 0 0 1 1.714 1.718M11.797 2.988 10.8 1.725l-1.355.335c.86.143 1.657.467 2.352.928M8.5 3.102 7.065 5.584H9.94zM9.94 5.584 8.5 8.07h2.87zM11.37 8.071l-1.43 2.487h2.87zM7.065 10.558 8.5 8.071H5.63z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.94 10.558 1.43-2.487H8.5zM8.5 8.071l1.44-2.487H7.065zM5.63 8.071l-1.435 2.487h2.87zM8.5 3.102 7.065 5.584H9.94z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M9.94 5.584 8.5 8.07h2.87zM11.37 8.071l-1.43 2.487h2.87zM7.065 10.558 8.5 8.071H5.63z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.94 10.558 1.43-2.487H8.5zM8.5 8.071l1.44-2.487H7.065zM5.63 8.071l-1.435 2.487h2.87zM3.484 11.293l.29 1.428-2.05-.41z"
  })));
};
export default SvgIconAiriToken;